import angular from 'angular'

/**
 * A containter that wraps the side nav components
 */
angular.module('vend.ui').directive('vdSidebar', function () {
  return {
    link(scope, $element, attrs) {
      attrs.$addClass('vd-sidebar')
      attrs.$set('role', 'navigation')
    },
  }
})
